import Vue from 'vue'
import Router from 'vue-router'
import {
	Layout,
	Content
} from "../layout"; // 页面整体布局
import {
	topRouterMap
} from "./topRouter";
import {
	getToken
} from '@/utils/auth'

process.env.NODE_ENV === "development" ? Vue.use(Router) : null;

Vue.use(Router)

function filterTopRouterMap(name) {
	let router = topRouterMap.find((item) => {
		return item.parentName === name;
	});
	return router.data; // arr
}

/**
 * 1、roles:后台返回的权限结构;
 * 
 */
//手动跳转的页面白名单
const whiteList = [
	'/'
];
/**
 * path:''与path:'*'的区别：
 * 1、path:'*', 会匹配所有路径
 * 2、path:''，也是会匹配到路由
 * 
 */
//默认不需要权限的页面
export const constantRouterMap = [{
		path: '/',
		component: Layout,
		redirect: '/memberManage/fundList',
		hidden: true
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('@/page/login'),
		hidden: true
	},
	{
		path: '/404',
		component: () => import('@/page/errorPage/404'),
		hidden: true
	},
	{
		path: '/401',
		component: () => import('@/page/errorPage/401'),
		hidden: true
	},
	{
		path: '/memberManage',
		name: 'memberManage',
		meta: {
			title: '会员管理',
			icon: 'member'
		},
		component: Layout,
		children: [{
			path: 'fundList',
			name: 'memberLists',
			meta: {
				title: '会员列表',
				routerType: 'leftmenu'
			},
			component: () => import('@/page/fundList/fundList'),
		},{
			path: 'adminList',
			name: 'adminList',
			meta: {
				title: '管理员列表',
				routerType: 'leftmenu'
			},
			component: () => import('@/page/adminList/adminList'),
		},{
			path: 'classhourSpendList',
			name: 'classhourSpendLists',
			meta: {
				title: '课时账单列表',
				routerType: 'leftmenu'
			},
			component: () => import('@/page/classhourSpendList/classhourSpendList'),
			// hidden: true
		}, {
			path: 'memberRecycleBin',
			name: 'memberRecycleBin',
			meta: {
				title: '会员回收站',
				routerType: 'leftmenu'
			},
			component: () => import('@/page/memberRecycleBin/memberRecycleBin'),
			// hidden: true
		},{
			path: 'messageNotify',
			name: 'messageNotify',
			meta: {
				title: '短信通知列表',
				routerType: 'leftmenu'
			},
			component: () => import('@/page/messageNotify/messageNotify'),
			// hidden: true
		},{
			path: 'memberCoursePackage',
			name: 'memberCoursePackage',
			meta: {
				title: '会员课包列表',
				routerType: 'leftmenu'
			},
			component: () => import('@/page/memberCoursePackage/memberCoursePackage'),
			hidden: true
		}]
	},
	{
		path: '/studentManage',
		name: 'studentManage',
		meta: {
			title: '学员管理',
			icon: 'student',
		},
		component: Layout,
		children: [{
			path: 'studentList',
			name: 'studentLists',
			meta: {
				title: '学员列表',
				routerType: 'leftmenu'
			},
			component: () => import('@/page/studentList/studentList'),
		},{
			path: 'studentsRecycleBin',
			name: 'studentsRecycleBin',
			meta: {
				title: '学生回收站',
				routerType: 'leftmenu'
			},
			component: () => import('@/page/studentsRecycleBin/studentsRecycleBin'),
			// hidden: true
		} ,{
			path: 'eventNote',
			name: 'eventLists',
			meta: {
				title: '事件备注',
				routerType: 'leftmenu'
			},
			hidden: true,
			component: () => import('@/page/eventList/eventList'),
		}, {
			path: 'courseRecord',
			name: 'recordList',
			meta: {
				title: '课堂记录',
				routerType: 'leftmenu'
			},
			hidden: true,
			component: () => import('@/page/recordList/recordList'),
		}, {
			path: 'studentAndClassTypeList',
			name: 'studentAndClassTypeList',
			meta: {
				title: '学员可选班级类型',
				routerType: 'leftmenu'
			},
			hidden: true,
			component: () => import('@/page/studentAndClassTypeList/studentAndClassTypeList')
		}]
	},
	{
		path: '/courseManage',
		name: 'courseManage',
		meta: {
			title: '课程管理',
			icon: 'course1',
		},
		component: Layout,
		children: [{
				path: 'unBeginCourseList',
				name: 'unBeginCourseList',
				meta: {
					title: '未完课列表',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/unbeginCourseList/unbeginCourseList'),
			},
			{
				path: 'finishedCourseLists',
				name: 'finishedCourseLists',
				meta: {
					title: '完课列表',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/beginCourseList/beginCourseList'),
			}, 
			{
				path: 'cancelCourseList',
				name: 'cancelCourseList',
				meta: {
					title: '取消课程列表',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/cancelCourseList/cancelCourseList'),
			},
			{
				path: 'courseDetails',
				name: 'courseDetails',
				meta: {
					title: '课程详情',
					routerType: 'leftmenu'
				},
				hidden: true,
				component: () => import('@/page/courseDetails/courseDetails'),
			}
		]
	},
	{
		path: '/typeManage',
		name: 'typeManage',
		meta: {
			title: '类型管理',
			icon: 'course'
		},
		component: Layout,
		children: [{
				path: 'appointmenttypes',
				name: 'appointmenttypes',
				meta: {
					title: '预约类型列表',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/appointmenttypes/appointmenttypes')
			},
			{
				path: 'coursetypes',
				name: 'coursetypes',
				meta: {
					title: '课程类型列表',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/coursetypes/coursetypes')
			},
			{
				path: 'classtypes',
				name: 'classtypes',
				meta: {
					title: '班级类型列表',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/classtypes/classtypes')
			}
		]
	},
	{
		path: '/coursePackageManage',
		name: 'coursePackageManage',
		meta: {
			title: '课包管理',
			icon: 'package'
		},
		component: Layout,
		children: [{
				path: 'schoolLists',
				name: 'schoolLists',
				meta: {
					title: '校区列表',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/schoolInfo/schoolInfo')
			},
			{
				path: 'coursepackages',
				name: 'coursepackages',
				meta: {
					title: '课包列表',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/coursepackages/coursepackages')
			},
			{
				path: 'coursepackagesRecycleBin',
				name: 'coursepackagesRecycleBin',
				meta: {
					title: '课包回收站',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/coursepackagesRecycleBin/coursepackagesRecycleBin')
			}
		]
	},
	{
		path: '/shouyeManage',
		name: 'shouyeMange',
		meta: {
			title: '首页管理',
			icon: 'aboard'
		},
		component: Layout,
		children: [{
				path: 'showLists',
				name: 'showLists',
				meta: {
					title: '展示栏目列表',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/showList/showList'),
			},
			{
				path: 'coachLists',
				name: 'coachLists',
				meta: {
					title: '教练列表',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/coachList/coachList'),
			},
			{
				path: 'courseResourse',
				name: 'courseResourse',
				meta: {
					title: '课程地点列表',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/teachingpoint/teachingpoint'),
			}
			// ,
			// {
			// 	path: 'notification',
			// 	name: 'notification',
			// 	meta: {
			// 		title: '消息提示',
			// 		routerType: 'leftmenu'
			// 	},
			// 	component: () => import('@/page/fundList/fundList'),
			// }
		]
	},
	{
		path: '/resourceManage',
		name: 'resourceManage',
		meta: {
			title: '资源管理',
			icon: 'resource',
		},
		component: Layout,
		children: [{
				path: 'excel',
				name: 'excel',
				meta: {
					title: '预约情况',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/courseBookList/courseBookList'),
			},
			{
				path: 'operationRecord',
				name: 'operationRecord',
				meta: {
					title: '操作记录列表',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/operationrecord/operationrecord'),
			},
			{
				path: 'locationAndClasstypeAndCoursepackage',
				name: 'locationAndClasstypeAndCoursepackage',
				meta: {
					title: '地点与班级类型关系列表',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/locationAndClasstypeAndCoursepackage/locationAndClasstypeAndCoursepackage'),
			},
			{
				path: 'classtypeAndTime',
				name: 'classtypeAndTime',
				meta: {
					title: '班级类型与时间列表',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/classtypeAndTime/classtypeAndTime'),
			},
			{
				path: 'locationAndCounts',
				name: 'locationAndCounts',
				meta: {
					title: '地点与学员人数列表',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/locationAndCounts/locationAndCounts'),
			}
			// ,
			// {
			// 	path: 'notification',
			// 	name: 'notification',
			// 	meta: {
			// 		title: '消息提示',
			// 		routerType: 'leftmenu'
			// 	},
			// 	component: () => import('@/page/fundList/fundList'),
			// }
		]
	},
]

//注册路由
const router = new Router({
	// mode: 'history', // 默认为'hash'模式
	mode: 'hash',
	// base: process.env.BASE_URL, // 添加跟目录,对应服务器部署子目录
	routes: constantRouterMap
})

// 添加路由守卫
router.beforeEach((to, from, next) => {
	// const isLogin = getToken('Admin-Token');
	const loginStatus = router.app.$cookies.get("status");
	console.log("loginStatus:" + loginStatus);
	// console.log("token:" + isLogin);
	if (to.path == "/login" || to.path == "/register") {
		next();
	} else {
		loginStatus == "logined" ? next() : next("/login");
		// isLogin ? next() : next("/login");
	}
})

export default router;

//异步路由（需要权限的页面）
export const asyncRouterMap = [
	// {
	// 	path: '/userManager',
	// 	name: 'userManage',
	// 	component: Layout,
	// 	meta: {
	// 		title: '用户管理',
	// 		icon: 'iconuser',
	// 	},
	// 	noDropdown: true,
	// 	children: [{
	// 		path: 'userList',
	// 		meta: {
	// 			title: '用户管理',
	// 			icon: 'iconuser',
	// 			routerType: 'leftmenu'
	// 		},
	// 		component: () => import('@/page/userList/userList'),
	// 	}]
	// },
	// {
	// 	path: '/share',
	// 	name: 'share',
	// 	component: Layout,
	// 	meta: {
	// 		title: '分享功能',
	// 		icon: 'iconshare',
	// 	},
	// 	noDropdown: true,
	// 	children: [{
	// 		path: 'share',
	// 		meta: {
	// 			title: '分享功能',
	// 			icon: 'iconshare',
	// 			routerType: 'leftmenu'
	// 		},
	// 		component: () => import('@/page/share'),
	// 	}]
	// },
	// {
	// 	path: '/infoManage',
	// 	name: 'infoManage',
	// 	meta: {
	// 		title: '信息管理',
	// 		icon: 'iconinfo',
	// 	},
	// 	component: Layout,
	// 	children: [{
	// 			path: 'infoShow',
	// 			name: 'infoShow',
	// 			meta: {
	// 				title: '个人信息',
	// 				icon: 'iconinfo',
	// 				routerType: 'leftmenu',
	// 				titleList: [{
	// 						"path": "infoShow1",
	// 						"title": "个人信息子菜单1"
	// 					},
	// 					{
	// 						"path": "infoShow2",
	// 						"title": "个人信息子菜单2"
	// 					},
	// 					{
	// 						"path": "infoShow3",
	// 						"title": "个人信息子菜单3"
	// 					},
	// 					{
	// 						"path": "infoShow4",
	// 						"title": "个人信息子菜单4"
	// 					},
	// 					{
	// 						"path": "infoShow5",
	// 						"title": "个人信息子菜单5"
	// 					}
	// 				]
	// 			},
	// 			component: Content,
	// 			children: filterTopRouterMap('infoShow')
	// 		},
	// 		{
	// 			path: 'infoModify',
	// 			name: 'infoModify',
	// 			meta: {
	// 				title: '修改信息',
	// 				icon: 'iconinfo',
	// 				routerType: 'leftmenu',
	// 				titleList: [{
	// 						"path": "infoModify1",
	// 						"title": "修改信息子菜单1"
	// 					},
	// 					{
	// 						"path": "infoModify2",
	// 						"title": "修改信息子菜单2"
	// 					},
	// 					{
	// 						"path": "infoModify3",
	// 						"title": "修改信息子菜单3"
	// 					}
	// 				]
	// 			},
	// 			component: Content,
	// 			children: filterTopRouterMap('infoModify')
	// 		}
	// 	]
	// },
	{
		path: '/fundManage',
		name: 'fundManage',
		meta: {
			title: '资金管理',
			icon: 'iconpay3',
		},
		component: Layout,
		children: [{
				path: 'fundList',
				name: 'fundList',
				meta: {
					title: '资金流水',
					routerType: 'leftmenu'
				},
				component: () => import('@/page/fundList/fundList'),
			},
			// {
			// 	path: 'chinaTabsList',
			// 	name: 'chinaTabsList',
			// 	meta: {
			// 		title: '区域投资',
			// 		routerType: 'leftmenu'
			// 	},
			// 	component: () => import('@/page/fundList/chinaTabsList'),
			// }
		]
	},
	// {
	// 	path: '/fundData',
	// 	name: 'fundData',
	// 	meta: {
	// 		title: '资金数据',
	// 		icon: 'iconecharts',
	// 	},
	// 	component: Layout,
	// 	redirect: '/fundData/fundPosition',
	// 	children: [{
	// 			path: 'fundPosition',
	// 			name: 'fundPosition',
	// 			meta: {
	// 				title: '投资分布'
	// 			},
	// 			component: () => import('@/page/fundData/fundPosition')
	// 		},
	// 		{
	// 			path: 'typePosition',
	// 			name: 'typePosition',
	// 			meta: {
	// 				title: '项目分布'
	// 			},
	// 			component: () => import('@/page/fundData/typePosition')
	// 		},
	// 		{
	// 			path: 'incomePayPosition',
	// 			name: 'incomePayPosition',
	// 			meta: {
	// 				title: '收支统计'
	// 			},
	// 			component: () => import('@/page/fundData/incomePayPosition')
	// 		}
	// 	]
	// },
	// {
	// 	path: '/permission',
	// 	name: 'permission',
	// 	meta: {
	// 		title: '权限设置',
	// 		icon: 'iconpermission',
	// 		roles: ['admin', 'editor'] // you can set roles in root nav
	// 	},
	// 	component: Layout,
	// 	redirect: '/permission/page',
	// 	children: [{
	// 		path: 'page',
	// 		name: 'pagePer',
	// 		meta: {
	// 			title: '页面权限',
	// 			roles: ['admin'] // or you can only set roles in sub nav
	// 		},
	// 		component: () => import('@/page/permission/page'),
	// 	}, {
	// 		path: 'directive',
	// 		name: 'directivePer',
	// 		meta: {
	// 			title: '按钮权限',
	// 			roles: ['editor']
	// 		},
	// 		component: () => import('@/page/permission/directive'),
	// 	}]
	// },
	// {
	// 	path: '/error',
	// 	component: Layout,
	// 	name: 'errorPage',
	// 	meta: {
	// 		title: '错误页面',
	// 		icon: 'iconError'
	// 	},
	// 	children: [{
	// 			path: '401',
	// 			name: 'page401',
	// 			component: () => import('@/page/errorPage/401'),
	// 			meta: {
	// 				title: '401',
	// 				noCache: true
	// 			}
	// 		},
	// 		{
	// 			path: '404',
	// 			name: 'page404',
	// 			component: () => import('@/page/errorPage/404'),
	// 			meta: {
	// 				title: '404',
	// 				noCache: true
	// 			}
	// 		}
	// 	]
	// },
	// {
	// 	path: '*',
	// 	redirect: '/404',
	// 	hidden: true
	// }
];



/**
 *  路由设置要求：
 * 1、该路由有子菜单,可以设置多层嵌套路由children;如果没有子菜单,不需要设置children;通过item.children.length来判断路由的级数;
 * 2、登录成功后,定位到系统首页时,需要加载页面整体布局组件Layout并进行子路由定向加载;
 * 
 * 按需加载路由组件的2种方法：
 * 1、component: () => import('@/page/login')
 * 2、component:resolve => require(['@/page/fundPosition'], resolve)
 * 
 * 
 * 
 * 什么情况下，路由会定位到404页面?
 * 路由中redirect:'',不起作用？
 * 三级子菜单要在顶部展示？
 * 
 * 
 * 
 */